/* src/app/main/header/header.component.css */
.top-header {
  background-color: #213654;
  padding-top: 10px;
  padding-bottom: 10px;
}
.top-header ul {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  list-style: none;
}
.top-header ul .login-btn {
  background-color: transparent;
  border: 1px solid #fff;
  font-size: 14px;
  border-radius: 2px;
  padding: 5px 15px;
  font-family: "Roboto", sans-serif;
}
.top-header ul li:last-child {
  position: relative;
}
.top-header ul li:last-child::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #ccc;
  left: 0;
}
.top-header .fa {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.logo-img {
  width: 254px;
  height: auto;
}
.navbar-light .navbar-nav .nav-link {
  color: #545454;
  font-size: 18px;
  font-weight: 600;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;
}
.navbar-light .navbar-nav .nav-item:last-child .nav-link {
  padding-right: 0px;
}
.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: #e7792b;
}
.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-item:focus {
  outline: none;
}
.navbar-expand-lg .navbar-nav .dropdown-menu {
  border-top: 5px solid #e7792b;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 0;
  margin-left: 10px;
  margin-top: -1px;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #e7792b !important;
  background-color: transparent;
}
.navbar-nav a {
  color: #545454;
}
.navbar-nav .fa-home {
  font-size: 24px;
  padding-top: 31px;
  padding-bottom: 31px;
  padding-left: 25px;
  padding-right: 25px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  cursor: pointer;
  margin-left: 45px;
}
.nav-item .nav-link:hover,
.nav-item .nav-link:focus {
  background-color: rgb(0 0 0 / 0.07);
}
.nav-item .nav-link.active {
  color: #e7792b !important;
  background-color: transparent;
}
.navbar-nav .dropdown-item.active {
  color: #E8882D !important;
  text-decoration: none;
  background-color: transparent;
}
::ng-deep .modal-open .modal {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: flex-end !important;
}
.modal-auth-popup .modal-content {
  background-color: #213654;
  color: #fff;
  padding: 10px 30px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 3px 6px #00000029;
}
.modal-auth-popup .modal-header .close {
  background-color: #fff;
  opacity: 1;
  padding: 0px 5px;
  border-radius: 100%;
}
.modal-auth-popup .modal-title {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}
.modal-auth-popup .sub-text {
  font-weight: 300;
}
.modal-auth-popup .input-field {
  font-size: 13px;
  height: auto;
  border-radius: 3px;
  width: 100%;
  border: 1px solid #fff;
  padding: 7px 10px 7px 35px;
  background-color: transparent;
  color: #fff;
  font-weight: 300;
}
.modal-auth-popup .input-field::placeholder {
  color: #fff;
  opacity: 1;
}
.modal-auth-popup .input-field:-ms-input-placeholder {
  color: #fff;
}
.modal-auth-popup .input-field::-ms-input-placeholder {
  color: #fff;
}
.modal-auth-popup .input-field:focus {
  outline: none;
}
.modal-auth-popup .input-container {
  margin-bottom: 12px;
  position: relative;
}
.modal-auth-popup .input-container .fa {
  position: absolute;
  left: 13px;
  top: 10px;
}
.modal-auth-popup .modal-footer {
  border-top: none;
  padding-left: 0;
  padding-top: 0;
}
.modal-auth-popup .btn-submit {
  background-color: #E8882D;
  color: #fff;
  padding: 5px 25px;
}
.modal-auth-popup .btn-reset {
  background-color: transparent;
  color: #fff;
  padding: 5px 25px;
  border: 1px solid #fff;
}
.modal-auth-popup .modal-body {
  padding-bottom: 0px;
  padding-left: 0;
  padding-right: 0;
}
.modal-auth-popup .modal-header {
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 1px solid rgb(255 255 255 / 0.2);
  padding-bottom: 10px;
}
.modal-auth-popup .form-check-input {
  margin-left: 0px;
  margin-right: 8px;
  margin-top: 8px;
  position: relative;
}
.cust-recaptcha {
  transform: scale(0.77);
  -webkit-transform: scale(0.77);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
}
.form-tabs li {
  font-size: 16px;
}
.form-tabs li:first-child {
  padding-right: 15px;
  color: #FF8F40;
  border-right: 1px solid rgb(255 255 255 / 0.2);
}
.form-tabs li:last-child {
  padding-left: 15px;
}
#modalSigninForm form {
  border-bottom: 1px solid rgb(255 255 255 / 0.2);
}
#modalSigninForm .other-auth-links p {
  margin-bottom: 8px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: initial;
    margin-top: 52px;
    margin-right: 113px;
    width: 340px;
  }
}
@media (min-width: 1920px) {
  .logo-img {
    width: 44%;
  }
}
@media (min-width: 1600px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 24px;
    padding-top: 36px;
    padding-bottom: 36px;
  }
  .navbar-nav .fa-home {
    font-size: 30px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .logo-img {
    height: auto;
  }
  .top-header ul .login-btn {
    font-size: 15px;
    padding: 7px 15px;
  }
  .top-header .fa {
    font-size: 22px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 18px;
  }
  .navbar-nav .fa-home {
    font-size: 26px;
    padding-top: 32px;
  }
}
@media (device-width: 1280px) {
  .logo-img {
    width: 72%;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg .navbar-collapse {
    flex-basis: 100%;
  }
  .nav-item.dropdown:hover .dropdown-menu {
    display: block !important;
  }
}
@media (min-width: 768px) {
  .navbar {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (device-width: 768px) {
  .logo-img {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .res-disp-flex {
    display: flex;
    align-items: center;
  }
  .res-w-100 {
    width: 100%;
  }
  .navbar-light .navbar-nav .nav-link {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0;
    padding-left: 20px;
  }
  .navbar {
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .navbar-collapse {
    position: absolute;
    background-color: #fff;
    width: 100%;
    top: 58px;
    left: 0;
    z-index: 9;
    padding-left: 15px;
  }
  .nav-item.dropdown:hover .dropdown-menu {
    width: 92%;
  }
  .navbar-nav .fa-home {
    margin-left: 20px;
  }
}
@media (max-width: 767px) {
  .logo-img {
    width: 60%;
  }
}
@media (max-width: 350px) {
  .navbar {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
/*# sourceMappingURL=header.component.css.map */
